var ManageFavorites = React.createClass({
  propTypes: {
    initialMyFavorites: React.PropTypes.arrayOf(React.PropTypes.object),
    groupFavorites: React.PropTypes.arrayOf(React.PropTypes.object),
    pageSize: React.PropTypes.number,
    showFavoriteSearch: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      pageSize: 5,
      initialMyFavorites: [],
      groupFavorites: [],
      showFavoriteSearch: false
    }
  },
  getInitialState() {
    return {
      activeTab: "my",
      showEditControls: false,
      myFavorites: this.props.initialMyFavorites,
      favoriteQuery: ''
    }
  },
  navClicked(value) {
    this.setState({activeTab: value,
      showEditControls: false});
  },
  editClicked() {
    this.setState({showEditControls: !this.state.showEditControls});
  },
  deleteClicked(fav) {
    let {myFavorites} = this.state;
    let index = myFavorites.indexOf(fav);
    let data = { favoriteID: fav.id }
    data.SToken = Config.csrf.value;

    let url = `${Config.contextPath}/controller/delete/myfavorites/`;
    $.post(url, data);

    // optimistic remove from array
    myFavorites.splice(index, 1);
    this.setState({myFavorites: myFavorites});
  },handleChange: function(e) {
    this.setState({ favoriteQuery: e.target.value });
  },
   handleKeyPress: function(event){
    if(event.key === 'Enter' || event.keyCode == '13'){
        event.preventDefault();
        let favoriteQuery = this.state.favoriteQuery;
        let url = `${Config.contextPath}/ss/?querytext=${favoriteQuery}&favoritesOnly=true&tabid=2#t=kbResults`;
        window.location.href = url;
    }
  },
  favClicked(fav, e) {
    e.preventDefault();

    let url = `${Config.contextPath}/app/core/ralogger.jsp`;
    let data = {
      action: "VIEWFAVORITE",
      description: fav.description,
      docid: fav.solutionID,
      SToken: Config.csrf.value,
      accessmethod: sessionStorage.getItem("accessmethod")
    };

    let targetUrl = fav.isSolution ?
      `${Config.contextPath}/app/portlets/results/viewsolution.jsp?ifv=true&solutionid=${fav.solutionID}` : fav.url;

    $.post(url, data)
      .always(() => location.href = targetUrl);
  },
  renderNav() {
    let { groupFavorites } = this.props;
    let {
      myFavorites,
      activeTab
    } = this.state;

    if (groupFavorites.length == 0) return;

    return (
      <TabBar activeKey={activeTab} onChange={this.navClicked} className="-sm">
        <Tab eventKey="my">{Labels.getLabel("My Favorites")}</Tab>
        <Tab eventKey="group">{Labels.getLabel("Suggested Favorites")}</Tab>
      </TabBar>
    )
  },
  renderSearchForm(){
    if (!this.props.showFavoriteSearch) {
      return(
        <span></span>
      )
    }
    let href = `${Config.contextPath}/ss/?querytext=${this.state.favoriteQuery}&favoritesOnly=true&tabid=2#t=kbResults`;
    return (
      <div id="liveSearchSS" className="live-search">
        <input type="text" id="grid-search-box" name="grid-search-box" aria-label="Grid Search box" className="form-control"
               placeholder={Labels.getLabel("Search favorites")} maxlength="200" onChange={this.handleChange} onKeyPress ={this.handleKeyPress}
        />
          <a href={href} aria-label={Labels.getLabel("Search Favorites, new tab")}>
            <i id="grid-search-box-icon" className="glyphicon glyphicon-search"></i>
          </a>
      </div>
    )
  },
  renderToolbar() {
    let {
      activeTab,
      myFavorites,
      showEditControls
    } = this.state;

    let showEditLink = activeTab == "my" && myFavorites.length > 0;

    if (!showEditLink) return;

    return (
      <div id="favoriteToolBar" className="aside__wrap aside__ctrls text-right">
        <EditLinkToggle
          onClick={this.editClicked}
          editEnabled={showEditControls} />
      </div>
    )
  },
  renderMyFavorite(fav) {
    let href = fav.isSolution ?
      `${Config.contextPath}/app/portlets/results/viewsolution.jsp?ifv=true&solutionid=${fav.solutionID}` : fav.url;

    return (
      <EditableListItem
        key={fav.id}
        showDelete={this.state.showEditControls}
        onDelete={this.deleteClicked.bind(this, fav)}>
        <a href={href} onClick={this.favClicked.bind(this, fav)}>{fav.description}</a>
      </EditableListItem>
    );
  },
  renderGroupFavorite(fav) {
    return (
      <li>
        <a href={fav.url} onClick={this.favClicked.bind(this, fav)}>{fav.description}</a>
      </li>
    );
  },
  render() {
    let {
      activeTab,
      myFavorites,
      showEditControls
    } = this.state;

    let items, renderItem, pageSize;
    if (activeTab == "my") {
      renderItem = this.renderMyFavorite;
      items = myFavorites;
    } else {
      renderItem = this.renderGroupFavorite;
      items = this.props.groupFavorites;
    }

	pageSize = this.props.pageSize;

    let content = items.length ?
      <BasicPagerList
        className={classNames({"padded-list": showEditControls, "link-list": !showEditControls}, "-bordered", "-hover")}
        items={items}
        renderItem={renderItem}
		pageSize={pageSize} /> :
      <NoContent message={Labels.getLabel("No saved favorites")} />;

    return (
      <div>
        <h2 className="aside__title">
          {Labels.getLabel("Favorites")}
        </h2>

        {this.renderNav()}

        <div className="row">
          <div className="col-md-12">
            <div className="input-group">
              <span className="input-group-btn" role="presentation">
                {this.renderToolbar()}
              </span>
              {this.renderSearchForm()}
            </div>
          </div>
        </div>

        {content}
      </div>
    )
  }
})